import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { LabelM, LabelXS } from '#src/atoms/typography/index.tsx';
import { Dots } from '#src/atoms/ui/Dots/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useIntlContext } from '#src/contexts/intl/index.ts';
import { useFiatBalance } from '#src/hooks/wallets/useFiatBalance.ts';
import { faFiatCurrencySymbols } from '#src/lib/fiat.ts';

type Props = { collapsed?: boolean };

export const FiatBalance = ({ collapsed }: Props) => {
  const { formatNumber } = useIntlContext();
  const { currentUser } = useCurrentUserContext();
  const { fiatCurrency, availableBalanceWithCurrencySymbol, availableBalance } =
    useFiatBalance({
      notation: 'compact',
      compactDisplay: 'short',
    });

  const hideBalance = currentUser?.userSettings?.hideBalance;

  if (collapsed) {
    return (
      <Vertical gap={0.5} center>
        <FontAwesomeIcon icon={faFiatCurrencySymbols[fiatCurrency]} size="1x" />
        <LabelXS bold>
          {hideBalance ? (
            <Dots count={3} size="small" />
          ) : (
            formatNumber(availableBalance, {
              currency: fiatCurrency,
              notation: 'compact',
              compactDisplay: 'short',
            })
          )}
        </LabelXS>
      </Vertical>
    );
  }

  return hideBalance ? (
    <Horizontal center>
      <FontAwesomeIcon icon={faFiatCurrencySymbols[fiatCurrency]} size="1x" />
      <Horizontal gap={0.5}>
        <Dots count={3} size="small" />
      </Horizontal>
    </Horizontal>
  ) : (
    <LabelM bold>{availableBalanceWithCurrencySymbol}</LabelM>
  );
};
